import React, { memo, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import MypageReturn from '../molecules/MypageReturn';
import { FixedValuesContext } from '../context/FixedValues';
import { StepNavigation as StepType } from '../types/Template';
import { Row, Col } from 'react-bootstrap';
import Popup from '../molecules/Popup';
import { mypage_url } from '../Const';
interface Props {
  opened_mypage: boolean;
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  moveNextStep: () => void;
  requestModule: () => void | boolean;
  handleClickTempSave: () => void; // 一時保存
  setStepNavigation: React.Dispatch<React.SetStateAction<StepType>>;
  requestModuleAutodisplay: () => void | boolean;
}

// KWANKGM03110_住宅ローンしっかり審査事前審査申込入力詳細 フッタボタン
const FooterPreExaminationApplicationHousingLoanFirmlyInputDetail: React.FC<Props> = ({
  opened_mypage,
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
  requestModule,
  handleClickTempSave,
  setStepNavigation,
  requestModuleAutodisplay,
}) => {
  const history = useHistory();
  const [modal_temp_save, setModalTempSave] = useState(false);
  /**
   * ナビゲーションと画面を確認画面に遷移
   */
  const handleClickNext = async () => {
    const autodisplay_result = await requestModuleAutodisplay();
    const valid_result = await requestModule();

    // バリデーションエラーがあるか判定
    if (!valid_result) {
      return;
    }

    moveNextStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/upload`);
  };

  // 「一時保存する」ボタンクリック時のアクション
  const handleClickOpenTempSave = () => {
    handleClickTempSave(); // 一時保存のCommonAPIをキックする
    setModalTempSave(true);
  };

  const outPutButton = () => {
    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-no-arrow">
        <div className="text-left sp-button-center">
          <a className="btn btn-xl btn-main-color" onClick={handleClickOpenTempSave}>
            一時保存する
          </a>
        </div>
      </Col>
    );
  };

  return (
    <>
      <Row className={'my-5'}>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <p>
              連帯債務者等がいる場合、連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
              <br />
              連帯債務者等の確認状況はマイページから確認可能です。
            </p>
          </Col>
        {outPutButton()}
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
          <div className="text-right sp-button-center">
            <a
              className="btn btn-xl btn-main-color sp-btn-height ml-auto"
              onClick={handleClickNext}
            >
              事前審査申込をする
            </a>
          </div>
        </Col>
      </Row>
      <MypageReturn is_staff={is_staff} />
      <Popup
        title="一時保存完了"
        text="入力内容を一時保存しました。このまま入力を続けますか？"
        first_button={{
          label: '入力を続ける',
          variant: 'success',
          handleClick: () => setModalTempSave(false),
        }}
        second_button={{
          label: 'マイページへ戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalTempSave(false);
            location.href = mypage_url;
          },
        }}
        toggleClose={() => setModalTempSave(false)}
        toggleShow={modal_temp_save}
      />
    </>
  );
};

export default memo(FooterPreExaminationApplicationHousingLoanFirmlyInputDetail);
